import React, { createContext, useState } from 'react';

export const ConfirmContext = createContext();

function ConfirmContextProvider({ children }) {
  const [confirm, setConfirm] = useState({
    title: '',
    description: '',
    isOpen: false,
    proceed: null,
    cancel: null,
  });

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ConfirmContext.Provider value={[confirm, setConfirm]}>
      {children}
    </ConfirmContext.Provider>
  );
}

export default ConfirmContextProvider;
